<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-title>
        Data Entry Setting
        <v-spacer />
        <add-button
          :disabled="!isFormValid"
          :permission="true"
          @action="addRow"
          >Add
        </add-button>
      </v-card-title>

      <v-divider />

      <v-data-table
        :headers="headers"
        :items="dateEntrySettings"
        item-value="id"
        class="elevation-1 data-entry-table"
        :items-per-page="100"
        hide-default-footer
      >
        <template v-slot:item.grade_id="{ item, index }">
          <v-select
            v-model="item.grade_id"
            :items="grades"
            label="Grade"
            dense
            outlined
            hide-details
            @change="fetchSections(item, index)"
          />
        </template>

        <template v-slot:item.section_id="{ item, index }">
          <!-- :items="item.sections" -->
          <v-select
            v-model="item.section_id"
            :items="getFilteredSections(item, index)"
            label="Section"
            dense
            outlined
            hide-details
            :disabled="!item.grade_id"
          />
        </template>

        <template v-slot:item.from_date="{ item, index }">
          <v-calendar-field
            :id-val="'from_date_' + index"
            v-model="item.from_date"
            label="From Date"
          />
        </template>

        <template v-slot:item.to_date="{ item, index }">
          <v-calendar-field
            :id-val="'to_date_' + index"
            v-model="item.to_date"
            label="To Date"
          />
        </template>

        <template v-slot:item.status="{ item }">
          <v-select
            v-model="item.status"
            :items="entry_status"
            label="Status"
            dense
            outlined
            hide-details
          />
        </template>

        <template v-slot:item.teacher_id="{ item }">
          <v-autocomplete
            v-model="item.teacher_id"
            :items="teachersList"
            label="Teacher"
            dense
            outlined
            hide-details
            item-text="name"
            item-value="id"
          />
        </template>

        <template v-slot:item.action="{ item, index }">
        
          <delete-button
            v-if="shouldShowDelete(index, item) && item.id !== null"
            :permission="true"
            @agree="removeRow(index, item.id)"
          />

           <v-btn
            v-if="shouldShowDelete(index, item) && item.id == null"
            x-small
            outlined
            color="error"
            class="ml-1 mt-1 mb-1"
            @click="removeRow(index, item.id)"
          >
            <v-icon x-small>clear</v-icon
            ><strong class="ml-1">Delete</strong>
          </v-btn>
          <!-- <v-btn icon small color="red" @click="removeRow(index, item.id)" v-if="shouldShowDelete(index, item)">
            <v-icon>fa fa-minus</v-icon>
          </v-btn> -->
        </template>
      </v-data-table>

      <v-divider class="my-4" />

      <edit-button
        :disabled="!isFormValid || loader"
        @agree="dataEntrySettingUpdate"
        icon="mdi-content-save"
        :outlined="true"
        :large="true"
        :block="true"
        color="primary"
        label="Update Data Entry Setting"
        :permission="true"
        :loading="loader"
      />
    </v-card>
  </v-container>
</template>


<script>
import Mixins from "@/library/Mixins";

export default {
  mixins: [Mixins],
  data() {
    return {
      grades: [],
      teachersList: [],
      loader: false,
      headers: [
        { text: "Grade", value: "grade_id", width: '10', sortable: false, },
        { text: "Section", value: "section_id", sortable: false, },
        { text: "From Date", value: "from_date", sortable: false, },
        { text: "To Date", value: "to_date", sortable: false, },
        { text: "Status", value: "status", sortable: false, },
        { text: "Teacher", value: "teacher_id", sortable: false, },
        { text: "Action", value: "action", sortable: false, width: '100', sortable: false, },
      ],
     
      entry_status: [
        { text: "Active", value: "active" },
        { text: "Inactive", value: "inactive" },
      ],
      dateEntrySettings: [
        {
          id: null,
          grade_id: null,
          section_id: null,
          from_date: '',
          to_date: '',
          teacher_id: null,
          sections: [],
          status: 'active'
        },
      ],
    };
  },
  computed: {
    isFormValid() {
      return this.dateEntrySettings.every(
        (row) =>
          row.grade_id &&
          row.section_id &&
          row.from_date &&
          row.to_date &&
          row.teacher_id &&
          row.status
      );
    },
  },
  mounted() {
    this.getGrades();
    this.getTeachers();
    this.getDataEntrySettings();
  },
  methods: {
    getGrades() {
      this.$rest.get("/api/grades?slim=true").then(({ data }) => {
        this.grades = data.data.map((g) => ({
          text: g.name,
          value: g.id,
        }));
      });
    },
    getTeachers() {
      this.$rest.get("/api/teacher").then((res) => {
        this.teachersList = res.data.data;
      });
    },
    fetchSections(row, index) {
      if (!row.grade_id) return;
      this.$rest
        .get(`/api/section?grade=${row.grade_id}`)
        .then(({ data }) => {
          this.$set(this.dateEntrySettings[index], "sections", data.data.map((s) => ({
            text: s.name,
            value: s.id,
          })));
          this.dateEntrySettings[index].section_id = null;
        });
    },
    shouldShowDelete(index, item) {
      if(index !== 0) return true
      const isFilled =
        item.grade_id &&
        item.section_id &&
        item.from_date &&
        item.to_date &&
        item.teacher_id &&
        item.status;

      return this.dateEntrySettings.length >= 1 && isFilled;
    },
    addRow() {
      this.dateEntrySettings.push({
        id: null,
        grade_id: null,
        section_id: null,
        from_date: null,
        to_date: null,
        teacher_id: null,
        status: 'active',
        sections: [],
      });
    },
    removeRow(index, id=null) {
      this.dateEntrySettings.splice(index, 1);
      if(id) {
        this.$rest.delete('/api/data-entry-setting/'+id).then((res) => {
          this.$events.fire("notification", {
            message: "Data Entry Setting deleted Successfully",
            status: "success",
          });
          this.getDataEntrySettings();
        })
      }
      // if (this.dateEntrySettings.length === 0) {
      //   this.addRow();
      // }
    },
    getDataEntrySettings() {
      this.$rest.get('/api/data-entry-setting').then((res) => {
        const entries = res.data.data;
        this.dateEntrySettings = []; // clear existing
        if (entries.length === 0) {
          this.addRow();
          return;
        }

        entries.forEach((item, index) => {
          const newItem = {
            ...item,
            sections: [],
          };

          if (item.grade_id) {
            this.$rest.get(`/api/section?grade=${item.grade_id}`).then((sectionRes) => {
              newItem.sections = sectionRes.data.data.map((s) => ({
                text: s.name,
                value: s.id,
              }));

              // Manually force Vue to update the specific object
              this.$set(this.dateEntrySettings, index, newItem);
            });
          }

          // Push initially without sections (sections will populate once API resolves)
          this.dateEntrySettings.push(newItem);
        });
      });
    },

    dataEntrySettingUpdate() {
      this.loader = true
      const { sections, ...payload } = this.dateEntrySettings;
      this.$rest.post("/api/data-entry-setting", {data:payload})
        .then(() => {
          this.$events.fire("notification", {
            message: "Data Entry Setting Updated Successfully",
            status: "success",
          });

        this.getDataEntrySettings()
        }).catch(() => {
          this.$events.fire("notification", {
            message: "something went wrong!!",
            status: "error",
          });
        }).finally(() => {
          this.loader = false
        });
    },
    getFilteredSections(currentItem, currentIndex) {
      if (!currentItem.sections) return [];

      const usedSectionIds = this.dateEntrySettings
        .filter((item, i) => i !== currentIndex && item.grade_id === currentItem.grade_id)
        .map((item) => item.section_id);

      return currentItem.sections.filter(
        (section) => !usedSectionIds.includes(section.value)
      );
    },

  },
};
</script>

<style scoped>
.custom-table td {
  padding: 12px 8px !important;
  vertical-align: middle;
}
.custom-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
}
.custom-table {
  border-collapse: separate;
  border-spacing: 0 10px; /* adds vertical space between rows */
}

.data-entry-table ::v-deep th,
.data-entry-table ::v-deep td {
  padding: 8px 12px !important;
  vertical-align: middle;
}

.data-entry-table ::v-deep .v-input {
  margin-bottom: 0;
}

.data-entry-table ::v-deep .v-select,
.data-entry-table ::v-deep .v-autocomplete,
.data-entry-table ::v-deep .v-text-field {
  min-width: 140px;
}

.data-entry-table ::v-deep .v-btn {
  margin-left: 4px;
  margin-right: 4px;
}

.data-entry-table ::v-deep tr {
  border-bottom: 1px solid #e0e0e0;
}

</style>
